import React, { useEffect, useMemo } from 'react';
import { Image as BaseImage } from '@rneui/themed';
import { useBunnyOptimizedImageUri, useImageSize, } from "../../utils/images";
import { useTheme } from '../../hooks';
import { Image as SkeletonImage } from '../skeleton';
import FastImage from './FastImage';
import { BackgroundOnlyImage } from "./BackgroundOnlyImage";
export const UnmemoizedImage = ({ uri, style = {}, containerStyle = {}, heightConstraint, widthConstraint, isLoading = false, resizeMode = "contain", onSize = (_dimensions) => { }, defaultDimensions: dDims, }) => {
    const optimizedUri = useBunnyOptimizedImageUri(uri, {
        height: heightConstraint,
        width: widthConstraint,
    });
    const { colors, defaultCardAspectRatio, defaultCardHeight } = useTheme();
    const defaultDimensions = useMemo(() => dDims || {
        height: defaultCardHeight,
        width: defaultCardHeight * defaultCardAspectRatio,
    }, [dDims, defaultCardAspectRatio, defaultCardHeight]);
    const { aspectRatio = defaultCardAspectRatio } = useImageSize(optimizedUri);
    const imageStyle = useMemo(() => {
        const image = {};
        if (heightConstraint) {
            image.height = heightConstraint;
            image.width = heightConstraint * aspectRatio;
        }
        else if (widthConstraint) {
            image.height = widthConstraint / aspectRatio;
            image.width = widthConstraint;
        }
        else {
            image.height = defaultDimensions.height;
            image.width = defaultDimensions.height * aspectRatio;
        }
        return image;
    }, [
        defaultDimensions.height,
        heightConstraint,
        widthConstraint,
        aspectRatio,
        resizeMode,
    ]);
    useEffect(() => onSize(imageStyle), [
        imageStyle.height,
        imageStyle.width,
    ]);
    const Loading = React.createElement(SkeletonImage, { borderRadius: style.borderRadius, height: defaultDimensions.height, width: widthConstraint });
    if (optimizedUri && !isLoading) {
        return (React.createElement(BaseImage, { source: { uri: optimizedUri }, style: {
                ...imageStyle,
                ...style
            }, containerStyle: containerStyle, resizeMode: resizeMode, ImageComponent: FastImage, PlaceholderContent: Loading }));
    }
    else if (!uri && !isLoading) {
        const width = defaultDimensions.width || defaultCardHeight * defaultCardAspectRatio;
        const height = defaultDimensions.height || defaultCardHeight;
        const backgroundColor = colors.skeletonLoader;
        return React.createElement(BackgroundOnlyImage, { backgroundColor: backgroundColor, dimensions: { height, width } });
    }
    else {
        return Loading;
    }
};
export const Image = React.memo(UnmemoizedImage, (prev, next) => {
    return prev.uri === next.uri &&
        prev.isLoading === next.isLoading &&
        prev.widthConstraint === next.widthConstraint &&
        prev.heightConstraint === next.heightConstraint &&
        prev.defaultDimensions?.height === next.defaultDimensions?.height &&
        prev.defaultDimensions?.width === next.defaultDimensions?.width;
});
//# sourceMappingURL=Image.js.map